import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

import type { ExportProcessosArbitraisParams } from '../types/processosArbitraisStoreTypes';

export const selectProcessosArbitraisItems = (state: RootState) => state.arbitral.items;
export const selectProcessosArbitraisLoading = (state: RootState) => state.arbitral.isLoading;
export const selectProcessosArbitraisError = (state: RootState) => state.arbitral.error;
export const selectProcessosArbitraisIsExporting = (state: RootState) => state.arbitral.isExporting;
export const selectProcessosArbitraisPagination = (state: RootState) => state.arbitral.pagination;
export const selectProcessosArbitraisSummary = (state: RootState) => state.arbitral.summary;
export const selectProcessosArbitraisSituacaoOptions = (state: RootState) =>
  state.arbitral.situacaoOptions;
export const selectProcessosArbitraisReprocessandoInicioIds = (state: RootState) =>
  state.arbitral.reprocessandoInicioIds;
export const selectDashboardProcessosArbitrais = (state: RootState) => state.arbitral.dashboard;

/**
 * Recorte que a exportação usa quando a pessoa está no Dashboard: o da resposta na tela, com o
 * período já resolvido pelo core (dias civis de SP). `null` enquanto a tela não mostra uma
 * resposta: sem resposta, carregando outro recorte ou com erro, o slice ainda guarda a resposta
 * ANTERIOR, e exportá-la entregaria um arquivo de outro filtro.
 */
export const selectRecorteExportavelDoDashboard = createSelector(
  [selectDashboardProcessosArbitrais],
  ({ data, recorte, isLoading, error }): ExportProcessosArbitraisParams | null => {
    if (!data || !recorte || isLoading || error) return null;
    return {
      tab: 'ALL',
      status: recorte.status ? [recorte.status] : [],
      rito: recorte.rito ? [recorte.rito] : [],
      dataEntradaInicio: data.periodo.inicio,
      dataEntradaFim: data.periodo.fim,
      // O Dashboard não mostra os importados da plataforma antiga; o CSV dele também não.
      somenteDaPlataforma: true,
    };
  },
);
